import React from 'react';
import { FC } from 'react';

import MiuConsumptionComponent from './MiuConsumption';

const MiuConsumption: FC = () => {
  return <MiuConsumptionComponent />;
};
export default MiuConsumption;
